import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Edit, Trash2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import AdminLayout from "@/components/layout/AdminLayout";

export default function AdminCourses() {
  const [courses, setCourses] = useState([]);

  const load = () => api.get("/admin/courses").then((r) => setCourses(r.data));
  useEffect(() => { document.title = "Cursos — Admin"; load(); }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Excluir este curso, todos os módulos e aulas?")) return;
    try {
      await api.delete(`/admin/courses/${id}`);
      toast.success("Curso excluído");
      load();
    } catch (err) {
      toast.error(formatApiError(err));
    }
  };

  return (
    <AdminLayout>
      <div className="p-8 lg:p-12 max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-10">
          <div>
            <div className="eyebrow mb-2">Conteúdos</div>
            <h1 className="font-serif text-4xl" style={{ color: "var(--text-primary)" }}>Cursos & Aulas</h1>
          </div>
          <Link to="/admin/cursos/novo" className="btn-primary" data-testid="new-course-btn">
            <Plus size={16} /> Novo curso
          </Link>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {courses.map((c) => (
            <div key={c.id} className="brand-card overflow-hidden" data-testid={`admin-course-${c.id}`}>
              <div className="aspect-[4/3] overflow-hidden">
                {c.cover_url ? (
                  <img src={c.cover_url} alt={c.title} className="w-full h-full object-cover" />
                ) : (
                  <div className="w-full h-full flex items-center justify-center" style={{ background: "var(--bg)", color: "var(--text-secondary)" }}>Sem capa</div>
                )}
              </div>
              <div className="p-6">
                <div className="flex items-center gap-2 mb-2 text-xs uppercase tracking-widest">
                  <span style={{ color: c.status === "ativo" ? "#16a34a" : "#dc2626" }}>{c.status}</span>
                  {c.is_public && <span style={{ color: "var(--copper)" }}>· Aberto</span>}
                </div>
                <h3 className="font-serif text-xl mb-2 line-clamp-1" style={{ color: "var(--text-primary)" }}>{c.title}</h3>
                <p className="text-sm mb-4 line-clamp-2" style={{ color: "var(--text-secondary)" }}>{c.description}</p>
                <div className="flex gap-2">
                  <Link to={`/admin/cursos/editar/${c.id}`} className="btn-secondary flex-1" style={{ padding: "0.5rem 1rem", fontSize: "0.85rem" }} data-testid={`edit-course-${c.id}`}>
                    <Edit size={14} /> Editar
                  </Link>
                  <button onClick={() => handleDelete(c.id)} className="p-2 rounded-full border" style={{ borderColor: "var(--border)", color: "#dc2626" }} title="Excluir" data-testid={`delete-course-${c.id}`}>
                    <Trash2 size={14} />
                  </button>
                </div>
              </div>
            </div>
          ))}
          {courses.length === 0 && (
            <div className="col-span-full brand-card p-12 text-center" style={{ color: "var(--text-secondary)" }}>
              Nenhum curso ainda. Crie o primeiro.
            </div>
          )}
        </div>
      </div>
    </AdminLayout>
  );
}
